import { UsersThree } from "@phosphor-icons/react";

interface CandidatesLinkCellProps {
  unitId: string;
  count?: number;
}

/**
 * Candidates pill used in leegstand tables. Shows the number of non-archived
 * candidates for the unit and deep-links to /rental/candidacies pre-filtered
 * on that unit (in a new tab).
 */
export const CandidatesLinkCell = ({ unitId, count }: CandidatesLinkCellProps) => {
  const c = count ?? 0;
  const href = `/rental/candidacies?unitId=${encodeURIComponent(unitId)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      title={
        c > 0
          ? `Bekijk ${c} actieve kandidaat${c === 1 ? "" : "en"} voor ${unitId}`
          : `Bekijk kandidaten voor ${unitId}`
      }
      className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-1 text-xs font-medium transition-colors ${
        c > 0
          ? "border-moss-primary bg-moss-primary/5 text-moss-primary hover:bg-moss-primary/10"
          : "border-neutral-primary/20 bg-white text-neutral-secondary-mid hover:bg-neutral-primary/5"
      }`}
    >
      <UsersThree size={14} weight="duotone" />
      <span>{c}</span>
    </a>
  );
};

export default CandidatesLinkCell;
